import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Media from 'react-media'
import NRTListItem from "../../_common/ListItem"
import {icons} from "../CourseTrail/CourseTrailModule/CourseTrailContent"
import moment from "../../../helpers/moment"
import Download from '../../_common/_icons/Download'
import Spinner from '../../_common/Spinner'
import MCLoadingOverlay from "../../_minha-central/LoadingOverlay"

const MCEadContentsList = (props) => {

    const {
        contents,
        onContentClick,
        loadingDownload,
        loadingContents,
        notContents,
        callId
    } = props

    if (!contents)
        return null

    return (
        <div className='mc-ead-contents-list'>
            {
                (!contents || contents.length === 0 && notContents) &&
                <NRTListItem>
                    <span className={'title'}>
                            Não existem arquivos no momento.
                    </span>
                </NRTListItem>
            }
            {   loadingContents ? <MCLoadingOverlay show={true}/> :
                contents.map(content => {
                    return (
                    <NRTListItem showOnlySeparator
                                 key={content.code}
                                 onClick={() => onContentClick(content.path, content.title, content.code)}
                    >
                            {icons[content.type]}
                            <span className={'date'}>
                            {moment(content.date).format('DD/MM/YYYY')}
                            </span>

                            <span className={'title'}>
                            {content.title}
                            </span>
                            {
                                loadingDownload && callId == content.code ?
                                <Media query="(max-width: 425px)">
                                {matches => matches ?
                                    <Spinner width={18} /> : <Spinner width={25}/>}
                                </Media> :
                                <Media query="(max-width: 425px)">
                                {matches => matches ?
                                    <Download width={18} style={{ fill: 'var(--primary-color)' }} /> : <Download width={25} style={{ fill: 'var(--primary-color)' }} />}
                                </Media> 
                            }
                    </NRTListItem>
                )})
            }

        </div>
    )
}


MCEadContentsList.propTypes = {
    contents: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.any,
            date: PropTypes.object,
            title: PropTypes.string,
            id: PropTypes.string,
        })
    ),
    onContentClick: PropTypes.func
}

MCEadContentsList.defaultProps = {

}

export default MCEadContentsList



// WEBPACK FOOTER //
// ./src/components/_ead/ContentsList/index.js